module.exports = __webpack_public_path__ + "static/media/img-1.3c8cc7a9.jpg";